export default __webpack_public_path__ + "static/media/fette-logo.3303b8cb.svg";